module.exports = __webpack_public_path__ + "static/banner-moc-1-1-db177f7d836fd9ed750175abb89a7e2c.png";